import { RecordingStatus } from "@/modules/audio-recording/legacy";

export function canPressDone({
  status,
  isMicrophoneDisconnected,
  noteExistsRemotely,
}: {
  status: RecordingStatus;
  isMicrophoneDisconnected: boolean;
  noteExistsRemotely: boolean | undefined;
}): boolean {
  if (isMicrophoneDisconnected || !noteExistsRemotely) {
    return false;
  }

  if (
    status === RecordingStatus.LOCKED ||
    status === RecordingStatus.PAUSED ||
    status === RecordingStatus.RECORDING ||
    status === RecordingStatus.STOPPED ||
    status === RecordingStatus.UPLOADED
  ) {
    return true;
  }

  return false;
}

export function isFinishedRecording(status: RecordingStatus): boolean {
  return (
    status === RecordingStatus.STOPPED ||
    status === RecordingStatus.UPLOADING ||
    status === RecordingStatus.UPLOADED ||
    status === RecordingStatus.PROCESSING
  );
}

export function isProcessing(status: RecordingStatus): boolean {
  return status === RecordingStatus.PROCESSING || status === RecordingStatus.UPLOADING;
}

export function getProcessingLabel(
  status: RecordingStatus,
  progressPercent: number | null
): string {
  if (status === RecordingStatus.UPLOADING) {
    if (typeof progressPercent === "number" && Number.isFinite(progressPercent)) {
      const clamped = Math.min(100, Math.max(0, Math.round(progressPercent)));
      return `Uploading... (${clamped}%)`;
    }
    return "Uploading...";
  }

  if (status === RecordingStatus.PROCESSING) {
    if (typeof progressPercent === "number" && Number.isFinite(progressPercent)) {
      const clamped = Math.min(99, Math.max(0, Math.round(progressPercent)));
      return `Processing... (${clamped}%)`;
    }
    return "Processing...";
  }

  return "Processing...";
}
